import type { Nullable } from '../../../types';
import type { IubendaRepository } from '../../repositories/iubendaRepository';
import { Client } from '../../client';
import { Consent } from '../../../entities';
import type { ILegalNotice, ISubject } from '../../../entities';
import { handleErrors } from '../../../helpers';

export default class IubendaRepositoryImpl implements IubendaRepository {
  client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async createConsent(
    subject: ISubject,
    preferences: {
      general: boolean;
    },
    legalNotices: Nullable<Array<ILegalNotice>>
  ): Promise<boolean> {
    const { client } = this;
    const consent = new Consent(subject, preferences, legalNotices);

    return new Promise((resolve, reject) => {
      client
        .post('/consent', consent.toRequestData())
        .then((response) => {
          const status = response.status === 200;
          resolve(status);
        })
        .catch((err) => {
          const error = handleErrors(err);
          reject(error);
        });
    });
  }
}
